export const LOGIN_PATH = '/auth'
export const LOGOUT_PATH = '?state=logout'
export const PASSWORD_RECOVERY_PATH = '?state=password-recovery'
export const VERIFY_ACCOUNT_PATH = '?state=verify-account'
export const RESET_PASSWORD_PATH = '?state=reset-password'
export const CATALOG_PATH = '/catalog'

// SERVICES
export const SERVICES_PATH = '/services'
export const NEW_CLAIMS_PATH = '/services/new-claims'
export const SERVICE_INFO_PATH = '/services/:fileId'

// RENTALS (same UI as services; different `fileType` on APIs)
export const RENTALS_PATH = '/rentals'
export const RENTAL_INFO_PATH = '/rentals/:fileId'

export const CONTACT_PATH = '/contact'
export const HOME_PATH = '/home'
export const ANALYTICS_PATH = '/analytics'
export const SURVEY_PATH = '/survey'

// SETTINGS
export const SETTINGS_PATH = '/settings'
export const PROFILE_PATH = '/settings/profile'
export const ACCOUNT_SETTINGS_PATH = '/settings/account-settings'

// BOOKING
export const BOOKING_PATH = '/booking'
export const BOOKING_FLEET_PATH = '/booking/:appPath'
export const BOOKING_ARRIVAL_PATH = '/booking/arrival'
export const BOOKING_DETAILS_PATH = '/booking/details'

// DRIVER
export const DRIVER_PATH = '/driver'
export const DRIVER_FLEET_PATH = '/driver/:appPath'

// VEHICLE EVENTS
export const VEHICLE_EVENTS_PATH = '/vehicleEvents'
export const WORKSHOP_EVENTS_PATH = '/workshopEvents'
export const MECHANIC_EVENTS_PATH = '/mechanicEvents'
export const VEHICLE_EVENTS_INFO_PATH = '/vehicleEvents/:vehicleEventId'
export const WORKSHOP_EVENTS_INFO_PATH = '/workshopEvents/:vehicleEventId'
export const MECHANIC_EVENTS_INFO_PATH = '/mechanicEvents/:vehicleEventId'

// DOC TOKEN
export const DOCUMENT_TOKEN_PATH = '/doc/:docTokenId'
export const DOCUMENT_PATH = '/doc'

// REQUEST PHOTOS
export const REQUEST_PHOTOS_PATH = '/requestPhotos'
export const REQUEST_PHOTOS_FLEET_PATH = '/requestPhotos/:appPath'

// VW
export const VW_PUBLISH_CLOSE_PATH = '/vw/publish-close'
export const VW_DOCUMENT_TOKEN_PATH = '/vw/doc-token'

// ICON SHOWCASE
export const ICON_SHOWCASE_PATH = '/icons'
